import { type FC, type PropsWithChildren } from 'react';

import { OidcProvider, OidcSecure } from '@axa-fr/react-oidc';

import { getAuthConfig } from 'api/authentication/utils/getAuthConfig';
import {
  LoggedIn,
  LoggingIn,
  NotAuthenticated,
  Processing,
  SessionLost
} from 'components/feedback/state/authentication/AuthenticationStates';
import { ErrorCodes, ErrorPage } from 'components/feedback/state/errors/ErrorPage';

const configuration = getAuthConfig();

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  if (!configuration) {
    return <ErrorPage code={ErrorCodes.Generic} />;
  }

  return (
    <OidcProvider
      configuration={configuration}
      authenticatingErrorComponent={NotAuthenticated}
      sessionLostComponent={SessionLost}
      loadingComponent={LoggingIn}
      authenticatingComponent={Processing}
      callbackSuccessComponent={LoggedIn}
    >
      <OidcSecure>{children}</OidcSecure>
    </OidcProvider>
  );
};
